import React from "react";
import { currentDate } from "../utils/date";
import { format } from "date-fns";
import { utcToLocalDateString } from "../../../utils/systemSettings";
import moment from "moment";

export function ProgressBar({
  scope,
  getTimelinePosition,
  viewType,
  displayYearRange,
  isBaseline = false,
  baseline = null,
}) {
  const getBaselineDateRange = () => {
    return scope.startDate && scope.endDate
      ? `${formatDateString(scope.startDate)} - ${formatDateString(scope.endDate)}`
      : "";
  };

  const findScopeDates = (scope) => {
    // if (!scope?.tasks) {
    //   return {
    //     startDate: null,
    //     endDate: null,
    //   };
    // }
    // const validTasks = scope?.tasks?.filter(
    //   (task) => task.startDate !== null && task.endDate !== null
    // );

    // if (validTasks.length === 0) {
    //   return {
    //     startDate: null,
    //     endDate: null,
    //   };
    // }

    // const startDate = validTasks.reduce((earliest, task) => {
    //   const taskDate = new Date(task.startDate);
    //   return earliest === null || taskDate < earliest ? taskDate : earliest;
    // }, new Date(validTasks[0].startDate));

    // const endDate = validTasks.reduce((latest, task) => {
    //   const taskDate = new Date(task.endDate);
    //   return latest === null || taskDate > latest ? taskDate : latest;
    // }, new Date(validTasks[0].endDate));

    // return {
    //   startDate,
    //   endDate,
    // };
    if (scope?.startDate && scope?.endDate) {
      return {
        startDate: moment(scope.startDate).toDate(),
        endDate: moment(scope.endDate).toDate(),
      };
    }

    return {
      startDate: null,
      endDate: null,
    };
  };
  const { startDate, endDate } = findScopeDates(scope);
  const { left, width, shouldRender } = getTimelinePosition(
    startDate,
    endDate,
    viewType,
    currentDate,
    displayYearRange
  );
  const formatDateString = (date) => {
    if (!date) return "";
    return moment(date).format("MMM DD");
  };

  const dateRangeString =
    startDate && endDate
      ? `${formatDateString(startDate)} - ${formatDateString(endDate)}`
      : "";

  if (!shouldRender) return null;

  return (
    <div
      className="h-[52px] py-1 absolute flex flex-col items-center z-1"
      style={{
        left: `${left}px`,
        top: `${isBaseline ? 46 : 0}px`,
      }}
    >
      <span className={`font-medium text-xs ${isBaseline ? "text-gray-500" : ""}`}>
        {isBaseline ? `baseline ${moment(baseline?.date).format("YYMMDD")} • ${scope.name}` : scope.name}
      </span>
      <div className="w-full flex flex-row items-center">
        <div
          className={`h-[4px] rounded-full ${isBaseline ? "bg-gray-300" : "bg-[#B4AEFF]"}`}
          style={{
            width: `${width - (scope?.isMilestone ? 16 :0)}px`,
          }}
        >
          <div
            className={`h-full rounded-full transition-all duration-300 bg-[#342C82]`}
            style={{ width: `${scope.progress}%` }}
          />
        </div>
        {scope?.isMilestone && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 28 28"
            fill="none"
          >
            <path
              d="M1.41421 15.4142C0.633165 14.6332 0.633164 13.3668 1.41421 12.5858L12.5858 1.41421C13.3668 0.633165 14.6332 0.633164 15.4142 1.41421L26.5858 12.5858C27.3668 13.3668 27.3668 14.6332 26.5858 15.4142L15.4142 26.5858C14.6332 27.3668 13.3668 27.3668 12.5858 26.5858L1.41421 15.4142Z"
              fill="#DFDDF3"
              stroke="#342C82"
            />
          </svg>
        )}
        <span className="font-semibold text-xs ml-1">{scope.progress}%</span>
      </div>
      <span className="text-gray-600 text-xs">
        {isBaseline ? getBaselineDateRange() : dateRangeString}
      </span>
    </div>
  );
}
